import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex pa-2" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c) => {
      return (_openBlock(), _createElementBlock("div", {
        key: c.childId,
        class: "icon mr-2"
      }, [
        _createElementVNode("img", {
          src: c.imageUrl? c.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'
        }, null, 8, _hoisted_2)
      ]))
    }), 128)),
    _createVNode(_component_v_btn, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/child/add', name: 'ChildAdd' }))),
      color: "primary",
      class: "white--text",
      depressed: "",
      icon: "",
      outlined: "",
      raised: "",
      height: "60",
      width: "60"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, { dark: "" }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" mdi-plus ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}